import React from 'react';

import FileDropzone from '../../common/components/FileDropzone/FileDropzone';
import UploadTagSheetContentWrapper from '../components/UploadTagSheetContentWrapper';
import UploadTagSheetHeader from '../components/UploadTagSheetHeader/UploadTagSheetHeader';
import { useUploadTagSheetContext } from '../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';
import {
  TAGS_UPLOAD_DROP_TEXT,
  TAGS_UPLOAD_DROPZONE_TITLE,
  TAGS_UPLOAD_FILE_LABEL,
  TAGS_UPLOAD_INFO_TEXT,
  TAGS_UPLOAD_STEP_TITLE,
  TAGS_UPLOAD_UPLOAD_MESSAGE,
} from './constants';
import useTagSheetParse from './useTagSheetParse/useTagSheetParse';

const TagUploadStep = (): React.JSX.Element => {
  const { selectedCampaigns, setParseResult, goToNextStep } = useUploadTagSheetContext();

  const campaignId = selectedCampaigns[0]?.id ?? '';

  const {
    hovering,
    getRootProps,
    getInputProps,
    percentUploaded,
    loading,
    cancelRequest,
    fileAddedName,
    onParseTagSheet,
  } = useTagSheetParse({
    campaignId,
    onSuccess: (result) => {
      setParseResult(result);
      goToNextStep();
    },
  });

  return (
    <div>
      <UploadTagSheetHeader
        title={TAGS_UPLOAD_STEP_TITLE}
        confirmButtonDisabled={!fileAddedName || loading}
        confirmText="Next"
        onNext={onParseTagSheet}
        loading={loading}
      />
      <UploadTagSheetContentWrapper>
        <FileDropzone
          title={TAGS_UPLOAD_DROPZONE_TITLE}
          uploadMessage={TAGS_UPLOAD_UPLOAD_MESSAGE}
          dropText={TAGS_UPLOAD_DROP_TEXT}
          fileLabel={TAGS_UPLOAD_FILE_LABEL}
          infoText={TAGS_UPLOAD_INFO_TEXT}
          formatLabel=".XLS, .XLSX"
          hovering={hovering}
          loading={loading}
          percentUploaded={percentUploaded}
          cancelRequest={cancelRequest}
          fileAddedName={fileAddedName}
          getRootProps={getRootProps}
          getInputProps={getInputProps}
        />
      </UploadTagSheetContentWrapper>
    </div>
  );
};

export default TagUploadStep;
